





























import {
  ref,
  createComponent,
  provide,
  inject,
  onMounted,
  computed,
  reactive,
  SetupContext
} from "@vue/composition-api";

import MemberKey from "@/components/member-key";
import WalletKey from "@/components/wallet-key";
import router from "@/router";

export default createComponent({
  setup(props: {}, context: SetupContext) {
    const memberStore = inject(MemberKey);
    if (!memberStore) {
      throw new Error(`${MemberKey} is not provided`);
    }

    const walletStore = inject(WalletKey);
    if (!walletStore) {
      throw new Error(`${WalletKey} is not provided`);
    }

    const moveLogin = () => {
      // @ts-ignore
      if (globalStore.isMobileWebView) {
        // @ts-ignore
        window.flutter_inappwebview.callHandler("moveLogin", "");
      } else {
        router.push("/login");
      }
    };

    memberStore.clearMember();
    walletStore.clearWalletList();
    walletStore.clearCompanyCodeList();
    walletStore.clearWalletHistoryList();

    const globalStore = context.root.$store;
    globalStore.auth.executeLogout();

    let errMsg = ref(globalStore.auth.response.data.detail);

    return { errMsg, moveLogin };
  }
});
